import appEvents from './../../../constants/appEvents.constant';
import mainEvents from './../../../modules/main/config/events.constant';

import templateDepartmentPopup from './../templates/modals/departmentConfirm.tmpl.html';
import {flightStates} from '../../flights/flights-routes';
import {hotelStates} from '../../hotels/hotels-routes';
import {carStates} from '../../cars/cars-routes';
import {railStates} from '../../ukrail/ukrail-routes';
import appCONST from '../../../constants/app.constants';

export default function HeaderController(
    $scope,
    $timeout,
    $window,
    $rootScope,
    $state,
    $uibModal,
    authService,
    sessionService,
    availableServices,
    userService,
    basketService,
    loginFactory,
    l10nService,
    localeService,
    sidebarService,
    hotelsFactory,
    localStorageService,
) {
    'ngInject';

    const defaultState = 'main.flights.roundtrip';
    const LAST_ATC_CHECK_LANG = 'last_atc_check_lang';

    const vm = this;
    Object.assign(vm, {
        hideUserBasket,
        $onInit,
        navigateTo,
        searchForSuitableHotelForTheTrip,
    });

    function $onInit() {
        initStates();
        $scope.departments = $rootScope.readOnlyMode ? [] : userService.getUserDepartments();
        $scope.readOnlyMode = $rootScope.readOnlyMode;
        $scope.availableServices = availableServices;
        $scope.isSeveralDepartments = isSeveralDepartments();
        $scope.getCurrentDepartmentName = getCurrentDepartmentName;
        $scope.logout = logout;
        $scope.toggleMainMenu = toggleMainMenu;
        $scope.goToProfile = loginFactory.goToProfile;
        $scope.changeDepartment = changeDepartment;
        $scope.getUserName = getUserName;
        $scope.isAuthorizedAgentUrl = authService.isAuthorizedAgentUrl();
        $scope.hideBasket = hideBasket;
        $scope.closeBasket = closeBasket;
        $scope.showBasketMain = showBasketMain;
        $scope.changeLanguage = changeLanguage;
        $scope.currentLanguage = $scope.isAuthorizedAgentUrl
            ? cultureToLanguage(localStorageService.get(LAST_ATC_CHECK_LANG))
            : getCurrentLanguage();
        $rootScope.currentLanguage = $scope.isAuthorizedAgentUrl
            ? localStorageService.get(LAST_ATC_CHECK_LANG)
            : localeService.getCurrentCulture();
        $scope.showLanguageSwitcher = !$scope.readOnlyMode && availableServices && availableServices.IsLanguageSwitcherEnabled;
        subscribe();
        $scope.hideUserBasket = hideUserBasket;
        $scope.showUserMenu = false;
        $scope.isFlightSearchAvailable = sidebarService.isFlightSearchAvailable;
        $scope.isHotelSearchAvailable = sidebarService.isHotelSearchAvailable;
        $scope.isCarSearchAvailable = sidebarService.isCarSearchAvailable;
        $scope.isEurostarSearchAvailable = sidebarService.isEurostarSearchAvailable;
        $scope.isRailSearchAvailable = sidebarService.isRailSearchAvailable;
        $scope.showAdmin = $rootScope.isAdmin();
        if ($scope.showAdmin) {
            initUrls();
        }
    }
    function initUrls() {
        const accessToken = authService.getAccessToken();
        $scope.adminLink = `${appCONST.adminUrl}?access_token=${encodeURIComponent(accessToken)}`;
        $scope.trainlineLink = `${appCONST.trainlineUrl}?token=${encodeURIComponent(accessToken)}`;
    }

    function initStates() {
        vm.hotelSearchState = hotelStates.MAIN;
        vm.flightSearchState = flightStates.ROUNDTRIP;
        vm.railSearchState = railStates.ROUNDTRIP;
        vm.carSearchState = carStates.MAIN;
    }

    function isSeveralDepartments() {
        return $scope.departments.length > 1;
    }

    function getCurrentDepartmentName() {
        const user = sessionService.getSessionItem('user');
        if (!user && !$scope.isAuthorizedAgentUrl) {
            return logout();
        }
        return $scope.isAuthorizedAgentUrl ? 'External Agent' : user.DepartmentName;
    }

    function getCurrentLanguage() {
        const culture = localeService.getCurrentCulture();

        return cultureToLanguage(culture);
    }

    function cultureToLanguage(culture) {
        if (culture === 'fr-FR') {
            return 'FR';
        }
        if (culture === 'nl-NL') {
            return 'NL';
        }
        if (culture === 'de-DE') {
            return 'DE';
        }
        if (culture === 'it-IT') {
            return 'IT';
        }
        return 'EN';
    }

    function redirectToDefaultPage() {
        $state.go(defaultState);
    }

    function reloadPage() {
        $state.go($state.current, {}, {reload: true});
    }

    function isTripListPage() {
        return $state.current.name === 'main.trip.list';
    }

    function showDepartmentPopup(userData) {
        const modalInstance = $uibModal.open({
            template: templateDepartmentPopup,
            size: 'sm',
            scope: $scope,
        });

        $scope.changeDepartmentOk = function() {
            modalInstance.close();

            basketService.clearBasket();
            authService.saveUser(userData);

            if (isTripListPage()) {
                reloadPage();
            } else {
                redirectToDefaultPage();
            }
        };
        $scope.changeDepartmentCancel = function() {
            modalInstance.close();
        };
    }

    function changeLanguage(culture) {
        $scope.currentLanguage = cultureToLanguage(culture);

        if (authService.isAuthorizedAgentUrl) {
            localStorageService.set(LAST_ATC_CHECK_LANG, culture);
            return l10nService.getAllTranslations(culture)
                .then(() => $window.location.reload());
        }

        return loginFactory.changeUserLanguage(culture)
            .then(loginFactory.fetchUserData)
            .then((userData) => {
                authService.saveUser(userData);
            })
            .then(loginFactory.getAvailableServices)
            .then((services) => {
                        authService.saveAvailableServices(services);
                    })
            .then(l10nService.getAllTranslations)
            .then(() => $window.location.reload());
    }

    function changeDepartment(department) {
        if (department.DepartmentId === userService.getCurrentDepartment()) {
            return;
        }

        loginFactory.changeDepartment(department)
            .then((userData) => {
                if (!basketService.isEmpty()) {
                    return showDepartmentPopup(userData);
                }

                authService.saveUser(userData);
                loginFactory.getAvailableServices()
                    .then((services) => {
                        authService.saveAvailableServices(services);
                        $rootScope.$broadcast(appEvents.AVAILABLE_SERVICES_CHANGE, services);

                        if (authService.dontHaveSearchPermission()) {
                            $state.go('main.trip.list');
                        }

                        if (isTripListPage()) {
                            reloadPage();
                        } else {
                            redirectToDefaultPage();
                        }
                    });
            });
    }

    function subscribe() {
        $scope.$on(appEvents.AVAILABLE_SERVICES_CHANGE, function(event, services) {
            $scope.availableServices = services;
        });
        $rootScope.$on(mainEvents.TOGGLE_BASKET, function(event, basketState) {
            $scope.basketState = basketState;
        });

        $rootScope.$on(mainEvents.TOGGLE_USER_MENU, function(event, userMenuState) {
            $scope.userMenuState = userMenuState;
        });

        $rootScope.$on(mainEvents.TOGGLE_LANG_MENU, function(event, langState) {
            $scope.langState = langState;
        });

        $scope.toggleUserMenu = basketService.toggleUserMenu;
        $scope.toggleLangMenu = basketService.toggleLangMenu;
        $scope.showUserMenu = false;
        $scope.showLangMenu = false;

        $rootScope.$on(mainEvents.HIDE_USER_MENU, () => basketService.toggleUserMenu($scope));
    }

    function closeBasket() {
        if ($scope.basketState) {
            $rootScope.$broadcast(mainEvents.HIDE_BASKET);
        }
    }
    function getUserName() {
        return $rootScope.readOnlyMode ? '' : userService.getUserName();
    }

    function hideBasket() {
        $rootScope.$broadcast(mainEvents.HIDE_BASKET);
    }

    function showBasketMain() {
        $scope.isCollapsedMenu = !$scope.isCollapsedMenu;
        $rootScope.$broadcast(mainEvents.SHOW_BASKET);
    }

    function toggleMainMenu() {
        $scope.isCollapsedMenu = !$scope.isCollapsedMenu;
        if ($scope.basketState) {
            $rootScope.$broadcast(mainEvents.HIDE_BASKET);
        }
    }

    function logout() {
        basketService.clearBasket();
        authService.logout();
    }

    function hideUserBasket() {
        if ($scope.showUserMenu) {
            $rootScope.$broadcast(mainEvents.HIDE_USER_MENU);
        }
    }

    function navigateTo(state) {
        $rootScope.$broadcast(mainEvents.HIDE_BASKET);

        $state.go(state);
    }

    function searchForSuitableHotelForTheTrip() {
        const params = basketService.getParamsToSearchForSuitableHotel();

        if (params) {
            hotelsFactory.openDropdown = true;
            hotelsFactory.address = `${params.city}`;

            hotelsFactory.setFormData({
                checkInDate: moment(params.fromDate).format(userService.getRegionalSettings().dateFormat),
                checkOutDate: moment(params.toDate).format(userService.getRegionalSettings().dateFormat),
                roomsQuantity: (params.travelers.adult + params.travelers.child + params.travelers.infant),
                occupantsQuantity: 1,
            });
        }

        $state.go(hotelStates.MAIN, {}, {reload: true});
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/main/controllers/headerController.js